import React, { memo, useCallback, useMemo, useEffect } from 'react';
import { Multiplier } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

const AddForm = ({
    form,
    onChange,
    onBlur,
    schema = [],
    modalInputRef,
    className,
    orientation = 'horizontal',
}) => {
    const { t } = useWeb5Context();
    const { values, errors, touched } = form;

    useEffect(() => {
        modalInputRef?.current?.focus();
    }, [modalInputRef]);

    const handleOnChange = useCallback(
        (value, newValue, index, schema, field, action) => {
            onChange && onChange({ value, newValue, index, field, action });
            setTimeout(() => {
                if (action === 'add') modalInputRef?.current?.focus();
            }, 50);
        },
        [modalInputRef, onChange],
    );

    const handleOnBlur = useCallback(
        (value, newValue, index, schema, field) => {
            onBlur && onBlur({ value, newValue, index, field });
        },
        [onBlur],
    );

    const getErrors = useMemo(() => {
        const newErrors = errors.reduce((arr, error, index) => {
            const newObj = Object.entries(error).reduce((obj, [key, value]) => {
                return {
                    ...obj,
                    [key]: touched[index] && touched[index][key] ? value : false,
                };
            }, {});
            return [...arr, newObj];
        }, []);

        return newErrors;
    }, [errors, touched]);

    const multiplierProps = useMemo(
        () => ({
            className,
            orientation,
            labelMode: 'vertical',
            separator: true,
            buttonLabel: t('label_add_more'),
            value: values,
            error: getErrors,
            schema: [
                {
                    fields: schema,
                },
            ],
            onChange: handleOnChange,
            onBlur: handleOnBlur,
        }),
        [className, orientation, t, values, getErrors, schema, handleOnChange, handleOnBlur],
    );

    return <Multiplier {...multiplierProps} />;
};

export default memo(AddForm);
